<div class="tabs" #tabsContainer>
  <div class="circle-indicator" #indicator></div>
  <ng-container *ngIf="tabs?.length > 0">
    <div
      class="tab ms-0"
      *ngFor="let tab of tabs; let i = index"
      [class.active]="selectedIndex === i"
      [ngStyle]="tabStyle"
      (click)="selectTab(i, $event)"
    >
      {{ tab }}
    </div>
  </ng-container>
</div>
  